import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUnlock,
  faLock,
  faBook,
  faBriefcase
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUnlock,
  faLock,
  faBook,
  faBriefcase
)

let pageMixin

// eslint-disable-next-line no-undef
if (APPSETTINGS.DataStore.store === 'ichabodcms') {
  pageMixin = {
    computed: {
      visibility() {
        return 'public'
      },
      icon() {
        if (this.node) {
          switch (this.visibility) {
          // Permission Icons
          case 'public':
            return 'unlock'
          case 'private':
            return 'lock'
          case 'member':
            return 'lock'
          case 'magazine':
            return 'book'
          case 'restricted':
            return 'briefcase'
          default:
            return 'unlock'
          }
        }
      }
    }
  }
}
else {
  pageMixin = {
    computed: {
      visibility() {
        return (this.item) ? this.$store.getters['node/visibility'](this.item.nid) : false
      },
      icon() {
        if (this.item) {
          switch (this.$store.getters['node/visibility'](this.item.nid)) {
          // Permission Icons
          case 'public':
            return 'unlock'
          case 'private':
            return 'lock'
          case 'member':
            return 'lock'
          case 'magazine':
            return 'book'
          case 'restricted':
            return 'briefcase'
          default:
            return 'unlock'
          }
        }
      }
    }
  }
}

export default pageMixin
export {
  pageMixin
}
